import { render, staticRenderFns } from "./VehicleTradeList.vue?vue&type=template&id=57463266&scoped=true"
import script from "./VehicleTradeList.vue?vue&type=script&lang=js"
export * from "./VehicleTradeList.vue?vue&type=script&lang=js"
import style0 from "./VehicleTradeList.vue?vue&type=style&index=0&id=57463266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57463266",
  null
  
)

export default component.exports